module.exports = __webpack_public_path__ + "img/chevron-up.3557b8f4.svg";